
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/avatar-dialog-view/jst/takePictureView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  buffer += "<div class=\"webcam-preview-wrapper\">\n  <img src=\"";
  if (helper = helpers.previewURL) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.previewURL); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" alt=\"\" class=\"webcam-preview\" />\n\n  <button type=\"button\" class=\"btn retry-snapshot-btn\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("profiles.take_picture_view")
  },data:data},helper ? helper.call(depth0, "profiles.take_picture_view.retry", "Retry", options) : helperMissing.call(depth0, "t", "profiles.take_picture_view.retry", "Retry", options)))
    + "\n  </button>\n</div>\n\n<div class=\"webcam-capture-wrapper\">\n  <div class=\"webcam-clip\">\n    <video autoplay class=\"webcam-live-preview pending\"></video>\n  </div>\n\n  <button type=\"button\" class=\"btn take-snapshot-btn\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("profiles.take_picture_view")
  },data:data},helper ? helper.call(depth0, "profiles.take_picture_view.take_picture", "Take Picture", options) : helperMissing.call(depth0, "t", "profiles.take_picture_view.take_picture", "Take Picture", options)))
    + "\n  </button>\n</div>\n\n<canvas class=\"webcam-preview-staging-area hidden\"></canvas>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  